var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3333 11H13.6667C12.2 11 11 12.2 11 13.6667V32.3333C11 33.8 12.2 35 13.6667 35H32.3333C33.8 35 35 33.8 35 32.3333V13.6667C35 12.2 33.8 11 32.3333 11ZM32.3333 32.3333H13.6667V13.6667H32.3333V32.3333ZM25.6133 23.3867L21.9467 28.1067L19.3333 24.96L15.6667 29.6667H30.3333L25.6133 23.3867Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.d0bdf31706c8aa464b1785524ad16473.svg";
export { ForwardRef as ReactComponent };